import './body.scss';

import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import constants from 'common/signature-modal/constants';

import Draw from './draw';
import Type from './type';
import Upload from './upload';
import Saved from './saved';

const messages = defineMessages({
  drawIn: {
    id: '',
    description: 'Text for a heading telling the user how to create their signature',
    defaultMessage: 'Draw it in',
  },
  typeIn: {
    id: '',
    description: 'Text for a heading telling the user how to create their signature',
    defaultMessage: 'Type it in',
  },
  uploadPhoto: {
    id: '',
    description: 'Text for a heading telling the user how to create their signature',
    defaultMessage: 'Use a photo of your signature',
  },
  uploadInitials: {
    id: '',
    description: 'Text for a heading telling the user how to create their initials',
    defaultMessage: 'Use a photo of your initials',
  },
  savedSignatures: {
    id: '',
    description: 'Text for a heading above a list of saved signatures',
    defaultMessage: 'Saved signatures',
  },
  savedInitials: {
    id: '',
    description: 'Text for a heading above a list of saved initials',
    defaultMessage: 'Saved initials',
  },
});

class Body extends React.PureComponent {

  currentTabRef = React.createRef();

  getSignatureData() {
    return this.currentTabRef.current.getSignatureData();
  }

  renderTitle() {
    const { intl, selectedTab, type } = this.props;

    switch (selectedTab) {
      case constants.TAB_DRAW:
        return intl.formatMessage(messages.drawIn);
      case constants.TAB_TYPE:
        return intl.formatMessage(messages.typeIn);
      case constants.TAB_UPLOAD:
        switch (type) {
          case constants.TYPE_SIGNATURE:
            return intl.formatMessage(messages.uploadPhoto);
          case constants.TYPE_INITIALS:
            return intl.formatMessage(messages.uploadInitials);
          default:
            throw new TypeError('Invalid type');
        }
      case constants.TAB_SAVED:
        switch (type) {
          case constants.TYPE_SIGNATURE:
            return intl.formatMessage(messages.savedSignatures);
          case constants.TYPE_INITIALS:
            return intl.formatMessage(messages.savedInitials);
          default:
            throw new TypeError('Invalid type');
        }
      default:
        throw new TypeError('Invalid tab');
    }
  }

  render() {
    const {
      type,
      enableInsertButtonCallback,
      selectedTab,
      signatures,
      getSignatureUrl,
      onSavedSignatureSelect,
      onSavedSignatureRemove,
      selectedSavedSignature,
      isUploadingSignature,
      uploadedSignature,
      onRotateSignature,
      uploadSignature,
      clearUploadedSignature,
      initialTypeInValue,
      getPaginatedSignatures,
      getPaginatedInitials,
      count,
    } = this.props;

    return (
      <div className="signature-modal-body">
        <div className="signature-modal-body__title">
          {this.renderTitle()}
        </div>
        {selectedTab === constants.TAB_DRAW && (
          <Draw
            ref={this.currentTabRef}
            enableInsertButtonCallback={enableInsertButtonCallback} />
        )}
        {selectedTab === constants.TAB_TYPE && (
          <Type
            ref={this.currentTabRef}
            enableInsertButtonCallback={enableInsertButtonCallback}
            initialTypeInValue={initialTypeInValue} />
        )}
        {selectedTab === constants.TAB_UPLOAD && (
          <Upload
            ref={this.currentTabRef}
            type={type}
            isUploadingSignature={isUploadingSignature}
            uploadedSignature={uploadedSignature}
            onRotateSignature={onRotateSignature}
            uploadSignature={uploadSignature}
            getSignatureUrl={getSignatureUrl}
            enableInsertButtonCallback={enableInsertButtonCallback}
            clearUploadedSignature={clearUploadedSignature} />
        )}
        {selectedTab === constants.TAB_SAVED && (
          <Saved
            ref={this.currentTabRef}
            type={type}
            enableInsertButtonCallback={enableInsertButtonCallback}
            signatures={signatures}
            getSignatureUrl={getSignatureUrl}
            selectedSavedSignature={selectedSavedSignature}
            onSavedSignatureRemove={onSavedSignatureRemove}
            onSavedSignatureSelect={onSavedSignatureSelect}
            getPaginatedSignatures={getPaginatedSignatures}
            getPaginatedInitials={getPaginatedInitials}
            count={count} />
        )}
      </div>
    );
  }
}

export default injectIntl(Body, { forwardRef: true });
